export default {
  nav: {
    title: 'Voip',
  }
}
